import { gql, useMutation } from "@apollo/client"

const SIGN_UP_FOR_NEWS = gql`
  mutation signUpForNews($email: String!, $url: String!) {
    signUpForNews(email: $email, url: $url) {
      success
    }
  }
`

interface SignUpForNewsMutation {
  signUpForNews: {
    success: boolean
  }
}

export const useSignUpForNews = () => {
  const [signUpForNews, { data, loading, error }] = useMutation<SignUpForNewsMutation>(SIGN_UP_FOR_NEWS)
  return { signUpForNews, data, loading, error }
}
